module.exports = __webpack_public_path__ + "static/media/mapbg_3x.28a89fed.png";